const ChatEvents = {
    OnChatJoinFailure: '_on_chat_join_failure',
    OnSendMessage: '_on_send_message',
    OnSendMessageSuccess: '_on_send_message_success',
    OnSendMessageFailure: '_on_send_message_failure',
    OnMessageTyping: '_on_message_typing',
    OnTypingArrived: '_on_typing_arrived',
    OnMessageArrived: '_on_message_arrived',
    OnStopWaiting: '_on_stop_waiting',
    OnParticipantsChanged: '_on_participants_changed',
    OnHideWaitingIndicator: '_on_hide_waiting_indicator',
    OnCallStatusArrived: '_on_calls_tatus_arrived',
    OnOperatorFilesArrived: '_on_operator_files_arrived',
    OnChatEnded: '_on_chat_ended',
    OnMessageIncoming: '_on_chat_incoming',
    OnChatReInit: '_on_chat_reinit',
    OnChatJoined: '_on_chat_joined',
    OnTransferRequested: '_on_transfer_requested',
    OnConnectionEstablished: '_on_connection_established',
    OnPokeMessageArrived: '_on_poke_message_arrived',
    OnHistoryLoadedCompletely: '_on_history_loaded_completely',
    OnHistoryStartLoading: '_on_history_start_loading',
    OnSMSChatTransferring: '_on_sms_chat_transfer_started',
    OnSMSChatTransferred: '_on_sms_chat_transfer_completed',
    OnPredefinedPokeMessage: '_on_predefined_poke_message',
    OnPredefinedCompleted: '_on_predefined_completed',
    onOperatorNotAvailable: '_operator-not-availble',
    OnChatRestart: '_on_chat_restart',
    OnChatTransferredToOperator: '_on_chat_transfer_to_operator',
    OnChatOptInConsentAccepted: '_on_chat_opt_in_consent_accepted',
    OnChatOptInConsentRejected: '_on_chat_opt_in_consent_rejected',
    OnChatOptInConsentAcceptedButNumberChangeRequested: '_on_chat_opt_in_consent_accepted_but_number_change_requested',
    onVideoGreetOverlay: 'on_video_greet_overlay',
    OnChatDisclaimerAccepted: '_on_chat_disclaimer_accepted',
    OnChatDisclaimerRejected: '_on_chat_disclaimer_rejected',
    OnWebToSmsRejected: '_on_web_to_sms_rejected',
    OnWebToSmsComplete: '_on_web_to_sms_complete',
    ChatIdleOut: 'chat_idle_out'
};
export default ChatEvents;
